<script setup>
import { useRouter } from "vue-router"

let router = useRouter();

</script>

<template>
  
  <div class="div-container" v-if="router.currentRoute._value.path === '/admin'">

    <div class="w-100 row gx-3 gy-3 justify-content-center align-self-center">
      <div class="col-12 col-md-4">
        <button class="col-12" @click="router.push({ name: 'Import' })">IMPORTAR / EXPORTAR</button>
      </div>

      <div class="col-12 col-md-4">
        <button class="col-12" @click="router.push({ name: 'SkillsTree' })">GERIR COMPETÊNCIAS</button>
      </div>
    </div>

    <div class="w-100 row gx-3 gy-3 justify-content-center align-self-center">
      <div class="col-12 col-md-4">
        <button class="col-12" @click="router.push({ name: 'TasksTree' })">GERIR ATIVIDADES E TAREFAS</button>
      </div>

      <div class="col-12 col-md-4">
        <button class="col-12" @click="router.push({ name: 'JobTasks' })">GERIR FUNÇÕES E ATIVIDADES</button>
      </div>
    </div>

    <div class="w-100 row gx-3 gy-3 justify-content-center align-self-center">
      <div class="col-12 col-md-4">
        <button class="col-12" @click="router.push({ name: 'Permissions' })">PERMISSÕES</button>
      </div>

      <div class="col-12 col-md-4">
        <button class="col-12" @click="router.push({ name: 'ManageParticipation' })">PROFICIÊNCIAS PARA O NÍVEL DE PARTICIPAÇÃO</button>
      </div>
    </div>

    <div class="w-100 row gx-3 gy-3 justify-content-center align-self-center">
      <div class="col-12 col-md-4">
        <button class="col-12" @click="router.push({ name: 'Alerts' })">ALERTAS</button>
      </div>
    </div>
  </div>
  
  <router-view></router-view>
</template>

<style scoped>

.div-container {
  margin: 10% auto;
  flex-direction: column;
  display: flex;
  gap: 13px;
}

</style>
